<template>
  <v-form ref="form" v-model="valid">
    <v-dialog v-model="show" max-width="500">
      <v-card>
        <v-card-title class="headline" primary-title>
          Settings
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-checkbox
                  v-model="showPrereleasesSetting"
                  label="Enable prerelease application type versions" 
                ></v-checkbox>
              </v-flex>      
              <v-flex xs12>
                <v-checkbox
                  v-model="showVersionsSetting"
                  label="Allow application type version selection" 
                ></v-checkbox>
              </v-flex>      
            </v-layout>
          </v-container>      
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click.stop="handleClose">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'dialog-settings',
  
  data() {
    return {
      valid: false,
      showPrereleasesSetting: false,
      showVersionsSetting: false,
    }
  },

  props: {
    value: Boolean,
  },

  watch: {
    show: function (val, oldVal) {
      if (val) {
        this.showPrereleasesSetting = this.showPrereleases;
        this.showVersionsSetting = this.showVersions;
      }
    }
  },

  methods: {
    ...mapActions('atmos', [
      'updateShowPrereleases',
      'updateShowVersions',
    ]),

    handleClose() {
      this.updateShowPrereleases(this.showPrereleasesSetting);
      this.updateShowVersions(this.showVersionsSetting);
      this.show = false;
    }    
  },

  computed: {
    ...mapGetters('atmos', [
      'showPrereleases',
      'showVersions'
    ]),

    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
}
</script>